import { Button } from '@/components/ui/button';
import {
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Check } from 'lucide-react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

const TrialWelcomeModal: FunctionComponent = () => {
  const { t } = useTranslation('common');
  const features = t('trialWelcome.features', { returnObjects: true }) as string[];

  return (
    <>
      <DialogHeader>
        <DialogTitle>{t('trialWelcome.title')}</DialogTitle>
        <DialogDescription>{t('trialWelcome.description')}</DialogDescription>
      </DialogHeader>
      <div className='space-y-2 py-2'>
        {features.map((feature) => (
          <div key={feature} className='flex items-center gap-2 text-sm'>
            <Check className='size-4 text-green-500 shrink-0' />
            <span>{feature}</span>
          </div>
        ))}
      </div>
      <DialogFooter>
        <DialogClose asChild>
          <Button>{t('trialWelcome.getStarted')}</Button>
        </DialogClose>
      </DialogFooter>
    </>
  );
};

export default TrialWelcomeModal;
